module.exports = __webpack_public_path__ + "img/personalPhotoes.e84d7423.svg";